import { useEffect, useRef } from 'react';
import { useRealtime } from './RealtimeProvider';

/**
 * Assina um evento canônico do namespace principal.
 *
 * O handler é mantido em ref, então não precisa ser memoizado pelo consumidor e
 * nunca sofre com "stale closure". A assinatura é refeita automaticamente após
 * (re)conexão ou troca de token.
 *
 * @param {string} eventType Nome canônico (ver `EVENT_TYPES`).
 * @param {(data: object, envelope: object) => void} handler
 * @param {{enabled?: boolean}} [options]
 */
export const useRealtimeEvent = (eventType, handler, options = {}) => {
  const { enabled = true } = options;
  const { subscribe, socketEpoch } = useRealtime();
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    if (!enabled || !eventType) return undefined;

    return subscribe(eventType, (data, envelope) => {
      try {
        if (typeof handlerRef.current === 'function') {
          handlerRef.current(data, envelope);
        }
      } catch (error) {
        console.error(`[Realtime] Erro no handler de '${eventType}':`, error);
      }
    });
  }, [eventType, enabled, subscribe, socketEpoch]);
};

export default useRealtimeEvent;
